import _asyncToGenerator from "/vercel/workpath0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/workpath0/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/workpath0/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/vercel/workpath0/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/vercel/workpath0/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/workpath0/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/workpath0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/workpath0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/workpath0/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { backend_util, buffer, DataStorage, engine, env, kernel_impls, KernelBackend, util } from '@tensorflow/tfjs-core';
var whereImpl = kernel_impls.whereImpl;
import { assertNotComplex } from './cpu_util';
export var MathBackendCPU = /*#__PURE__*/function (_KernelBackend) {
  _inherits(MathBackendCPU, _KernelBackend);

  var _super = _createSuper(MathBackendCPU);

  function MathBackendCPU() {
    var _this;

    _classCallCheck(this, MathBackendCPU);

    _this = _super.call(this);
    _this.blockSize = 48;
    _this.firstUse = true;
    _this.data = new DataStorage(_assertThisInitialized(_this), engine());
    return _this;
  }

  _createClass(MathBackendCPU, [{
    key: "nextDataId",
    value: function nextDataId() {
      return MathBackendCPU.nextDataId++;
    }
  }, {
    key: "write",
    value: function write(values, shape, dtype) {
      if (this.firstUse) {
        this.firstUse = false;

        if (env().get('IS_NODE')) {
          backend_util.warn('\n============================\n' + 'Hi there 👋. Looks like you are running TensorFlow.js in ' + 'Node.js. To speed things up dramatically, install our node ' + 'backend, which binds to TensorFlow C++, by running ' + 'npm i @tensorflow/tfjs-node, ' + 'or npm i @tensorflow/tfjs-node-gpu if you have CUDA. ' + 'Then call require(\'@tensorflow/tfjs-node\'); (-gpu ' + 'suffix for CUDA) at the start of your program. ' + 'Visit https://github.com/tensorflow/tfjs-node for more details.' + '\n============================');
        }
      }

      var dataId = {
        id: this.nextDataId()
      };
      this.data.set(dataId, {
        values: values,
        dtype: dtype,
        refCount: 1
      });
      return dataId;
    }
    /**
     * Create a data bucket in cpu backend.
     * @param shape Shape of the `TensorInfo`.
     * @param dtype DType of the `TensorInfo`.
     * @param values The value of the `TensorInfo` stored as a flattened array.
     */

  }, {
    key: "makeTensorInfo",
    value: function makeTensorInfo(shape, dtype, values) {
      var outId;

      if (dtype === 'string' && values != null && values.length > 0 && util.isString(values[0])) {
        var encodedValues = values.map(function (d) {
          return util.encodeString(d);
        });
        outId = this.write(encodedValues, shape, dtype);
      } else {
        outId = this.write(values, shape, dtype);
      }

      return {
        dataId: outId,
        shape: shape,
        dtype: dtype
      };
    }
    /** Return refCount of a `TensorData`. */

  }, {
    key: "refCount",
    value: function refCount(dataId) {
      if (this.data.has(dataId)) {
        var tensorData = this.data.get(dataId);
        return tensorData.refCount;
      }

      return 0;
    }
    /** Increase refCount of a `TensorData`. */

  }, {
    key: "incRef",
    value: function incRef(dataId) {
      var tensorData = this.data.get(dataId);
      tensorData.refCount++;
    }
    /** Decrease refCount of a `TensorData`. */

  }, {
    key: "decRef",
    value: function decRef(dataId) {
      if (this.data.has(dataId)) {
        var tensorData = this.data.get(dataId);
        tensorData.refCount--;
      }
    }
  }, {
    key: "move",
    value: function move(dataId, values, shape, dtype, refCount) {
      this.data.set(dataId, {
        values: values,
        dtype: dtype,
        refCount: refCount
      });
    }
  }, {
    key: "numDataIds",
    value: function numDataIds() {
      return this.data.numDataIds();
    }
  }, {
    key: "read",
    value: function () {
      var _read = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dataId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.readSync(dataId));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function read(_x) {
        return _read.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "readSync",
    value: function readSync(dataId) {
      var _this$data$get = this.data.get(dataId),
          dtype = _this$data$get.dtype,
          complexTensorInfos = _this$data$get.complexTensorInfos;

      if (dtype === 'complex64') {
        var realValues = this.readSync(complexTensorInfos.real.dataId);
        var imagValues = this.readSync(complexTensorInfos.imag.dataId);
        return backend_util.mergeRealAndImagArrays(realValues, imagValues);
      }

      return this.data.get(dataId).values;
    }
  }, {
    key: "bufferSync",
    value: function bufferSync(t) {
      var data = this.readSync(t.dataId);
      var decodedData = data;

      if (t.dtype === 'string') {
        try {
          // Decode the bytes into string.
          decodedData = data.map(function (d) {
            return util.decodeString(d);
          });
        } catch (_a) {
          throw new Error('Failed to decode encoded string bytes into utf-8');
        }
      }

      return buffer(t.shape, t.dtype, decodedData);
    }
  }, {
    key: "makeOutput",
    value: function makeOutput(values, shape, dtype) {
      var dataId = this.write(values, shape, dtype);
      return engine().makeTensorFromDataId(dataId, shape, dtype, this);
    }
    /**
     * Dispose the memory if the dataId has 0 refCount. Return true if the memory
     * is released or memory is not managed in this backend, false if memory is
     * not cleared.
     * @param dataId
     * @oaram force Optional, remove the data regardless of refCount
     */

  }, {
    key: "disposeData",
    value: function disposeData(dataId) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.data.has(dataId)) {
        this.data.get(dataId).refCount--;

        if (!force && this.data.get(dataId).refCount > 0) {
          return false;
        }

        var _this$data$get2 = this.data.get(dataId),
            complexTensorInfos = _this$data$get2.complexTensorInfos;

        if (complexTensorInfos != null) {
          this.disposeData(complexTensorInfos.real.dataId, true);
          this.disposeData(complexTensorInfos.imag.dataId, true);
        }

        this.data.delete(dataId);
      }

      return true;
    }
  }, {
    key: "disposeIntermediateTensorInfo",
    value: function disposeIntermediateTensorInfo(tensorInfo) {
      this.disposeData(tensorInfo.dataId);
    }
  }, {
    key: "time",
    value: function () {
      var _time = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(f) {
        var start, kernelMs;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                start = util.now();
                f();
                kernelMs = util.now() - start;
                return _context2.abrupt("return", {
                  kernelMs: kernelMs
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function time(_x2) {
        return _time.apply(this, arguments);
      }

      return time;
    }()
  }, {
    key: "memory",
    value: function memory() {
      return {
        // Unreliable due to automatic gc. The numbers above are cumulative.
        unreliable: true,
        reasons: ['The reported memory is an upper bound. Due to automatic garbage ' + 'collection, the true allocated memory may be less.']
      };
    }
  }, {
    key: "where",
    value: function where(condition) {
      assertNotComplex([condition], 'where');
      var condVals = this.readSync(condition.dataId);
      return whereImpl(condition.shape, condVals);
    }
  }, {
    key: "dispose",
    value: function dispose() {}
  }, {
    key: "floatPrecision",
    value: function floatPrecision() {
      return 32;
    }
    /** Returns the smallest representable number.  */

  }, {
    key: "epsilon",
    value: function epsilon() {
      return _get(_getPrototypeOf(MathBackendCPU.prototype), "epsilon", this).call(this);
    }
  }]);

  return MathBackendCPU;
}(KernelBackend);
MathBackendCPU.nextDataId = 0;